module.exports = __webpack_public_path__ + "media/images/flavours/icon-confit_dark-5dc129537c465e46cef9191923fce621.png";